// File: /js/shared/components/pageViewBeacon.js
//
// Human-confirmation beacon (activity measurement, 2026-08-12): one
// fire-and-forget `confirmPageView` POST per full page load, carrying
// `location.pathname`. The server recomputes the day-salted visitor hash
// from the request's own IP+UA and stamps `confirmed_at` on the page_view
// row this render just wrote — bots that never execute JS never confirm,
// which is the whole signal. No id, no cookie, no new client state.
//
// Rides `sendFetchRequest` (CSRF auto-attached, §1.3 rule-9 audited action
// `confirmPageView`). Failures are silently ignored — the beacon must never
// surface anything to the visitor. Sends at most once per document; pages
// the server never logged (admin/creator sessions, 404s) just no-op
// server-side.

import { sendFetchRequest } from '/js/shared/utils/AjaxUtils.js';

let sent = false;

export function initPageViewBeacon() {
  if (sent) return;
  sent = true;

  sendFetchRequest({
    payload: {
      name: 'confirmPageView',
      path: window.location.pathname,
    },
    onError: () => {}, // fire-and-forget — never bother the visitor
  });
}
